import { createSelector } from 'reselect';

import { getComponentProps } from '../form-designer/selectors/common.selectors';
import { getSelectedNavLink } from '../utils/SideNavigationUtils';

export const getDocRepositoryStore = (state) => state.documentRepository;

export const getLastSelectedRepositoryName = (state) =>
  state.savedSearchFilters?.lastSelectedRepositoryName ?? '';

export const getRepositoryInfo = createSelector(getDocRepositoryStore, (docRepoStore) => {
  const {
    documentRepositories,
    documentRepositoryDetails,
    loading,
    defaultRepository,
    isDefaultSetForUser,
  } = docRepoStore;

  return {
    documentRepositories,
    documentRepositoryDetails,
    loading,
    defaultRepository,
    isDefaultSetForUser,
  };
});

export const getCurrentRepositoryId = createSelector(
  [getDocRepositoryStore, getComponentProps],
  (docRepoStore, { repositoryName }) => {
    const currentRepository = docRepoStore.documentRepositories.find(
      (docRepo) => docRepo.Name === repositoryName
    );

    return currentRepository.Id;
  }
);

export const getIsAddRepositoryButtonEnabled = (state, props) => {
  const navigation = state.navigation;

  const navLink = getSelectedNavLink(navigation, props);

  if (navLink) {
    return navLink.Type !== 'RepositoryConfigurationListDisableAdd';
  }

  return false;
};
